 // see navigationAPI.js for api endpoint (store)

const state = {
  // users areas data -----------------------------------------------
  ifLoadingUsersAreas: false,
  usersAreas: [], //users authorized areas
  pendingInviteAreas: [], // areas that we have been invited to, but not accepted/declined

  spaceClicked: false,
};

const getters = {
  getIfLoadingUsersAreas: (state) => state.ifLoadingUsersAreas,
  getUsersAreas: (state) => state.usersAreas,
  getUsersAreasCount: (state) => state.usersAreas?.length || 0,
  getPendingInviteAreas: (state) => state.pendingInviteAreas,

  getSpaceClicked: (state) => state.spaceClicked, //if space clicked on home page - for analytics
};

const mutations = {
  setIfLoadingUsersAreas(state, data) {
    state.ifLoadingUsersAreas = data;
  },
  // all users areas --------------------------------------------
  setUsersAreas(state, data) {
    state.usersAreas = data;
  },

  setPendingInviteAreas(state, data) {
    state.pendingInviteAreas = data
  },

  setSpaceClicked(state, data) {
    state.spaceClicked = data
  }
};

const actions = {
  // CURRENT AREA DATA ---------------------------------------------
  async updateUsersAreas({commit},data) {
    commit('setUsersAreas',data)
    return
  },
  async fetchPendingInviteAreas({dispatch, commit}) {
    let res = await dispatch('api/nav/getPendingInvites')
    if(!res?.success) dispatch('popups/show/error/custom', 'getting your pending invites', {root: true})

    commit('setPendingInviteAreas', res.success)
  },
  async clearUsersAreas({commit}) {
    commit('setUsersAreas',[])
  },
  // ENTER SWITCH AREA PAGE ---------------------------------------------------
  async enterSwitchAreaPageHandler({commit,dispatch}) {
    commit('setIfLoadingUsersAreas', true)
    let res = await dispatch('api/nav/enterRoot')
    dispatch('enterSwitchAreaPageCallback',res)
    return res
  },
  async enterSwitchAreaPageCallback({dispatch, commit, getters}, res) {
    let data = res.success
    if(!data) {
      dispatch('clearUsersAreas')
      dispatch('popups/nav/errorLoadingUsersSpaces', () => location.reload(), {root: true})
      commit('setIfLoadingUsersAreas', false)
      return;
    }

    let areas = data.rootAreas
    let isExternalGuest = Boolean(data.isExternalGuest)

    dispatch('permissions/setSwitchSpacePagePermissions', {root: true})

    dispatch('current_user/setExternalGuest', isExternalGuest, {root: true})

    if (isExternalGuest) {
      // we're a guest! we shouldn't have access to root. Go to the register page
      dispatch('guest/registerAsGuestHandler', 'body', {root: true})
      return
    }

    dispatch('fetchPendingInviteAreas')

    await dispatch('updateUsersAreas', areas);
    dispatch('clearCurrentUsersRoom')
    dispatch('clearCurrentSpacePage')
    dispatch('clearCurrentAreaData')

    dispatch('sidebar/close')
    commit('setIfLoadingUsersAreas', false)
    dispatch('analytics/spacesCollection', [areas, isExternalGuest, getters.getPendingInviteAreas])
  },
  // switch area handler
  async switchAreaHandler({commit, dispatch},id) {
    if(!id) return console.log('no space id')
    dispatch('routing/goToArea', id)
    commit('setSpaceClicked', true)
  },

  async getRootAreas({dispatch}) {
    let res = await dispatch('api/nav/getRoot')
    return res?.success?.rootAreas || []
  },
  async getRootAdminAreas({dispatch}) {
    let res = await dispatch('api/nav/getRootAdmin')
    return res?.success?.adminLocations || []
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
